import { QueryParams } from 'api/types/common.types';
import { parseSearch } from 'containers/HomePageContainer/utils/parse-search';
import { useLocation } from 'react-router-dom';

export const useSearch = (): Required<QueryParams> => {
  const { search } = useLocation();

  return parseSearch(search);
};
